import { clsx } from 'clsx';
import { phoneFormatter } from '@utils';
import { makeStyles } from '@mui/styles';
import MaskedInput from 'antd-mask-input';
import { useController } from 'react-hook-form';
import React, { SyntheticEvent, useEffect } from 'react';
import TextField from '@mui/material/TextField';

interface Props {
  value: string | null;
  onChange: (value: string | null) => void;
  className?: string;
  error?: string;
  label?: string;
  disabled?: boolean;
}

export const PhoneControlledInput = ({
  value, onChange, className, error, label, disabled,
}: Props) => {
  const cls = useStyles();
  const allowedChars = '0123456789'.split('');

  let formattedValue = value ?? '';
  if (formattedValue[0] !== '+' || formattedValue[1] !== '5' || formattedValue[2] !== '2') {
    formattedValue = `+52${formattedValue.replace('+52', '').replace('+5', '').replace('+', '')}`;
  }

  return (
    <div className={className}>
      {label && (
        <label className={cls.label}>
          <span>{label}</span>
        </label>
      )}
      <div className={clsx('MuiInputBase-root', cls.box)}>
        <TextField
          disabled={disabled}
          onBeforeInputCapture={(e: any) => {
            if (disabled || !allowedChars.includes(`${e.data}`)) e.preventDefault();
          }}
          inputProps={{
            maxLength: 13,
          }}
          label={false}
          value={formattedValue}
          onChange={e => onChange(e.target.value)}
        />
        {error && <div className={cls.errorMessage}>{error}</div>}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  label: {
    display: 'block',
    color: '#042E6B',
    fontSize: 12,
    lineHeight: 1,
    marginTop: 4,
    marginLeft: 14,
    marginBottom: 3,
  },
  box: {
    overflow: 'hidden',
    '& > div > div': {
      background: 'transparent !important',
      '&:before': {
        display: 'none !important',
      },
      '&:after': {
        display: 'none !important',
      },
      '& input': {
        padding: '0 0 3px !important',
      },
    },
  },
  error: {
    borderBottom: '1px solid red !important',
  },
  errorMessage: {
    fontSize: 10,
    color: 'red',
    lineHeight: 1,
    fontWeight: 500,
  },
});
